import * as ACTION from '@Bootstraps/bootstrapActions';
import * as IMG from '@Utils/Images';
import Swal from 'sweetalert2';
import { useDispatch, useSelector } from 'react-redux';
import { useEffect, useMemo, useState } from 'react';
import { Container, Button, Modal, ModalHeader, ModalBody } from 'reactstrap';
import JWTDecode from 'jwt-decode';

export default function Component(props) {
  const [input, setInput] = useState({
    thumbnail: '',
    name: '',
    description: {
      section1: '',
      section2: '',
    },
    type: '',
    category: '',
    price: '',
  });
  const [loading, setLoading] = useState(false);
  const [showImage, setShowImage] = useState(IMG.EMPTY);
  const {
    accessToken,
    clothesEntityResponse,
    clothesInsertResponse,
    clothesUpdateResponse,
    clothesUpdateError,
  } = useSelector((state) => state);
  const { user } = useMemo(() => {
    return JWTDecode(accessToken);
  }, [accessToken]);
  const dispatch = useDispatch();

  const handleChange = (name, value) => {
    setInput((prevState) => {
      return { ...prevState, [name]: value };
    });
  };

  const handleSubmit = (action, isParams) => {
    setLoading(true);
    const formData = new FormData();

    for (let data in input) {
      if (data === 'description') {
        for (let itemObj in input[data]) {
          formData.append(`${data}.${itemObj}`, input[data][itemObj]);
        }
      } else {
        formData.append(data, input[data]);
      };
    };

    formData.delete('slug');

    dispatch(
      action(isParams ? { params: props?.id, data: formData } : formData)
    );
  };

  useEffect(() => {
    if (clothesInsertResponse) {
      Swal.fire({
        background: '#252336',
        color: '#3dcd55',
        title: 'Created!',
        text: clothesInsertResponse?.message,
        confirmButtonColor: '#3dcd55',
        icon: 'success',
      }).then(() => window.location.reload());
    };
  }, [clothesInsertResponse]);

  useEffect(() => {
    setShowImage(IMG.EMPTY);
    setInput({
      thumbnail: '',
      name: '',
      description: {
        section1: '',
        section2: '',
      },
      type: '',
      category: '',
      price: '',
    });

    if (props.showModal && props.slug) {
      dispatch(ACTION.clothesEntity(props.slug));
    };
  }, [props.showModal, props.slug]);

  useEffect(() => {
    if (clothesEntityResponse) {
      setInput(clothesEntityResponse?.data);
      setShowImage(clothesEntityResponse?.data?.thumbnail);
    }
  }, [clothesEntityResponse]);

  useEffect(() => {
    if (clothesUpdateResponse) {
      Swal.fire({
        background: '#252336',
        color: '#3dcd55',
        title: 'Updated!',
        text: clothesUpdateResponse?.message,
        confirmButtonColor: '#3dcd55',
        icon: 'success',
      }).then(() => window.location.reload());
    } else if (clothesUpdateError) {
      Swal.fire({
        background: '#252336',
        color: '#3dcd55',
        title: 'Failed!',
        text: clothesUpdateError?.message,
        confirmButtonColor: '#3dcd55',
        icon: 'error',
      });
    }
  }, [clothesUpdateResponse, clothesUpdateError]);

  useEffect(() => {
    if (user.role === 'user') {
      setLoading(true);
    };
  }, [user]);

  return (
    <Modal
      isOpen={props.showModal}
      toggle={props.toggle}
      ref={null}
      className="modal-lg"
    >
      <ModalHeader className="fw-bold m-0 px-4" toggle={props.toggle}>
        {props.id ? 'Edit Current' : 'Add New'} Cloth
      </ModalHeader>
      <ModalBody className="modalBody">
        <Container className="formTemplate placeholder-glow py-4">
          <form
            method="post"
            encType="multipart/form-data"
            onSubmit={(event) => {
              event.preventDefault();
              if (props.id) {
                if (user.role === 'admin') {
                  handleSubmit(ACTION.clothesUpdate, true);
                } else {
                  Swal.fire({
                    background: '#252336',
                    color: '#3dcd55',
                    title: 'Failed!',
                    text: 'Unauthorized Access',
                    confirmButtonColor: '#3dcd55',
                    icon: 'error',
                  });
                }
              } else {
                handleSubmit(ACTION.clothesInsert);
              }
            }}
          >
            <div className="inputContainer">
              <label
                htmlFor="thumbnail"
                className="cloth-img mb-4"
                style={{ backgroundImage: `url(${showImage})` }}
              />
              <input
                type="file"
                id="thumbnail"
                name="thumbnail"
                className="form-control"
                onChange={(e) => {
                  const thumbnail = e.target.files[0];
                  handleChange('thumbnail', thumbnail);
                  setShowImage(URL.createObjectURL(thumbnail));
                }}
                accept="image/*"
                disabled={props.slug && user.role === 'user'}
                hidden
              />
              <div>
                <label className="form-label normal mb-2" htmlFor="name">
                  Name
                </label>
                <input
                  type="text"
                  id="name"
                  name="name"
                  value={input?.name}
                  onChange={(e) => handleChange('name', e.target.value)}
                  disabled={props.slug && user.role === 'user'}
                  required
                />
              </div>
              <div className="description.section1">
                <label className="form-label normal mb-2" htmlFor="desc">
                  Description 1
                </label>
                <textarea
                  id="description.section1"
                  name="description.section1"
                  className="form-control w-100"
                  rows="5"
                  value={input?.description?.section1}
                  onChange={(e) =>
                    setInput((prev) => ({
                      ...prev,
                      description: {
                        ...prev.description,
                        section1: e.target.value,
                      },
                    }))
                  }
                  disabled={props.slug && user.role === 'user'}
                  required
                />
              </div>
              <div className="description.section2">
                <label className="form-label normal mb-2" htmlFor="desc">
                  Description 2
                </label>
                <textarea
                  id="description.section2"
                  name="description.section2"
                  className="form-control w-100"
                  rows="5"
                  value={input?.description?.section2}
                  onChange={(e) =>
                    setInput((prev) => ({
                      ...prev,
                      description: {
                        ...prev.description,
                        section2: e.target.value,
                      },
                    }))
                  }
                  disabled={props.slug && user.role === 'user'}
                  required
                />
              </div>
              <div className="type">
                <label className="form-label normal mb-2" htmlFor="desc">
                  Type
                </label>
                <select
                  name="type"
                  id="type"
                  className="form-select"
                  defaultValue={input?.type}
                  onChange={(e) => handleChange('type', e.target.value)}
                  disabled={props.slug && user.role === 'user'}
                  required
                >
                  <option disabled hidden value="">
                    Type Cloth
                  </option>
                  <option value="Shirt">Shirt</option>
                  <option value="Jacket">Jacket</option>
                  <option value="Short">Short</option>
                  <option value="Legging">Legging</option>
                  <option value="Dress">Dress</option>
                  <option value="Outfit">Outfit</option>
                </select>
              </div>
              <div className="category">
                <label className="form-label normal mb-2" htmlFor="desc">
                  Category
                </label>
                <select
                  name="category"
                  id="category"
                  className="form-select"
                  defaultValue={input?.category}
                  onChange={(e) => handleChange('category', e.target.value)}
                  disabled={props.slug && user.role === 'user'}
                  required
                >
                  <option disabled hidden value="">
                    Category Cloth
                  </option>
                  <option value="MEN">Men</option>
                  <option value="LADIES">Ladies</option>
                  <option value="KIDS">Kids</option>
                  <option value="ACCESSORIES">Accessories</option>
                </select>
              </div>
              <div>
                <label className="form-label normal mb-2" htmlFor="price">
                  Price
                </label>
                <input
                  type="number"
                  id="price"
                  name="price"
                  value={input?.price}
                  onChange={(e) => handleChange('price', e.target.value)}
                  disabled={props.slug && user.role === 'user'}
                  required
                />
              </div>
            </div>
            <Button
              type="submit"
              color="success"
              className="createButton py-2 mt-3 fw-semibold w-100"
              disabled={loading}
            >
              {props.id ? 'Edit' : 'Add'}
            </Button>
          </form>
        </Container>
      </ModalBody>
    </Modal>
  );
};